<template>
    <div id="app" v-if="dataComplete">
        <Welcome v-if="state === 'welcome'"
                 :message="messages.welcome"
                 :button_colors="settings.button_colors"
                 @start="changeState('start')"/>

        <Question v-if="state === 'start'"
                  :self="questions[questionIndex]"
                  :index="questionIndex"
                  :settings="settings"
                  :explanation="getExplanation"
                  :questions="getQuestions"
                  @next="nextQuestion"
                  @over="showResult"/>

        <Result v-if="state === 'result'"
                :messages="messages"
                :settings="settings"
                :correct="getCorrectAnswers"
                :questions="getQuestions"
                :action="getActionButton"
                @restart="restartGame"/>
    </div>
</template>

<script>
import Welcome from './components/Welcome.vue'
import Question from './components/Question.vue'
import Result from './components/Result.vue'

export default {
    name: 'Quiz',
    components: {
        Welcome,
        Question,
        Result
    },
    mounted: function () {
        this.state = 'welcome'
        this.questionIndex = 0
        this.correct = []
        this.title = window.data.title;
        this.settings = window.data.settings;
        this.messages = window.data.messages;
        this.action = window.data.action;

        if (this.settings.mode === 'shuffle') {
            this.questions = this.shuffle(window.data.questions)
        } else this.questions = window.data.questions;
    },
    data: function () {
        return {
            title: null,
            settings: null,
            questions: null,
            messages: null,
            action: null,
            state: null,
            questionIndex: null,
            correct: [],
        }
    },
    methods: {
        changeState($state) {
            this.state = $state;
        },
        nextQuestion($correct, $over) {
            if ($correct) this.correct.push(this.questionIndex);
            if ($over) this.showResult();
            else this.questionIndex++;
        },
        showResult() {
            this.questionIndex++;
            this.changeState('result');
        },
        shuffle(array) {
            let ctr = array.length, temp, index;
            while (ctr > 0) {
                index = Math.floor(Math.random() * ctr);
                ctr--;
                temp = array[ctr];
                array[ctr] = array[index];
                array[index] = temp;
            }

            return array;
        },
        restartGame() {
            this.correct = [];
            this.questionIndex = 0;

            // Shuffle Questions again, if shuffle mode
            if (this.settings.mode === 'shuffle') {
                this.questions = this.shuffle(window.data.questions);
            }

            this.changeState('welcome');
        },
        // openExternalUrl(){
        //   window.open(this.action.href, "_blank")
        // },
        // openNextStep(){
        //   if(this.action.href == "" || this.action.href == null || this.action.href == "#"){
        //     window.location.href = this.nextStep;
        //   }
        //   else window.open(this.action.href, "_blank");
        // }
    },
    computed: {
        getCorrectAnswers() {
            return this.correct;
        },
        dataComplete() {
            return this.title !== null && this.settings !== null && this.questions !== null && this.messages !== null && this.action !== null;
        },
        getActionButton() {
            return this.action;
        },
        getExplanation() {
            return this.questions[this.questionIndex].question.explanation
        },
        getQuestions() {
            let output = [];
            for (let i = 0; i < this.settings.rounds; i++) {
                if (this.correct.includes(i)) {
                    output.push('correct');
                } else if (i < this.questionIndex) {
                    output.push('wrong')
                } else if (i === this.questionIndex) {
                    output.push('active');
                } else {
                    output.push('open');
                }
            }
            return output;
        }
    }
}
</script>
<style lang="scss">
@import "./css/main.scss";
</style>
